<template>
  <div class="rank">
    <h4 class="title">{{ title }}</h4>
    <ul
      class="list"
      :style="{ height: height ? `${height}px` : 'auto', overflow: 'auto', 'text-align': 'center' }"
    >
      <li v-if="subTitle">
        <a-row :gutter="24">
          <a-col :span="4">排名</a-col>
          <a-col :span="6">
            {{ subTitle[0] }}
          </a-col>
          <a-col :span="4">
            {{ subTitle[1] }}
          </a-col>
          <a-col :span="4">
            {{ subTitle[2] }}
          </a-col>
          <a-col :span="6" v-show="subTitle[3]">
            {{ subTitle[3] }}
          </a-col>
        </a-row>
      </li>
      <li :key="index" v-for="(item, index) in list">
        <a-row :gutter="24">
          <a-col :span="4">
            <span :class="index < 3 ? 'active' : null">{{ index + 1 }}</span>
          </a-col>
          <a-col :span="6">
            {{ item.name }}
          </a-col>
          <a-col :span="4">
            {{ item.total }}
          </a-col>
          <a-tooltip v-if="item.warn">
            <template slot="title">
              <div v-for="i in item.warn.split(',')">{{ i }}</div>
            </template>
            <a-col :span="item.warn > -1 ? 4 : 10" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
              {{ item.warn }}
            </a-col>
          </a-tooltip>
        </a-row>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RankList',
  // ['title', 'list']
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: Array,
      default: null,
    },
    list: {
      type: Array,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    careAverage: {
      type: Array,
      default: null,
    },
  },
}
</script>

<style lang="less" scoped>
.rank {
  padding: 0;

  .list {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;

    li {
      margin-top: 16px;

      span {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        line-height: 22px;

        &:first-child {
          background-color: #f5f5f5;
          border-radius: 20px;
          display: inline-block;
          font-size: 12px;
          font-weight: 600;
          margin-right: 24px;
          height: 20px;
          line-height: 20px;
          width: 20px;
          text-align: center;
        }
        &.active {
          background-color: #314659;
          color: #fff;
        }
        &:last-child {
          float: right;
        }
      }
    }
  }
}

.mobile .rank {
  padding: 0 32px 32px 32px;
}
.ant-row {
  margin: 0 !important;
}
</style>
